function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { Radio as AntdRadio } from 'antd';
import useStyles from "./style";
var InternalRadio = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    cx = _useStyles.cx,
    prefixCls = _useStyles.prefixCls;
  return /*#__PURE__*/React.createElement(AntdRadio, _extends({
    ref: ref
  }, props, {
    className: cx(prefixCls + '-radio', styles.aelfDesignRadio)
  }));
});
if (process.env.NODE_ENV !== 'production') {
  InternalRadio.displayName = 'Radio';
}
var Radio = InternalRadio;
Radio.Button = AntdRadio.Button;
Radio.Group = AntdRadio.Group;
export default Radio;